module.exports = __webpack_public_path__ + "img/female.5747c72a.svg";